import { styled } from '@acko-tech/building-blocks.ui.common';

export const Title = styled.div`
  font-weight: 700;
  font-size: 1.625rem;
  line-height: 2.25rem;
  padding: 0 0 24px 0;

  @media screen and (min-width: 768px) {
    max-width: 560px;
    color: #040222;
    margin: 32px auto 32px auto;
    padding-bottom: 0;
    font-size: 2rem;
    line-height: 2.5rem;
  }
`;

export const FooterContent = styled.div`
  @media screen and (min-width: 768px) {
    max-width: 560px;
    margin: auto;
  }
`;

export const Highlight = styled.div`
  display: inline;
  color: ${(props) => props?.color || '#7c47e1'};
  font-size: ${(props) => props?.size || 'inherit'};
`;

export const Accordion = styled.div`
  @media screen and (min-width: 768px) {
    max-width: 560px;
    margin: auto;
  }
`;

export const AccordionItem = styled.div`
  border: ${(props) => (props?.open ? '1px solid #e7e7f0' : 'unset')};
  border-radius: 12px;
  margin-bottom: 16px;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    background: #ffffff;
    box-shadow: 0px 4px 4px -2px #36354c0f;
    border: 1px solid #e7e7f0;
    margin-bottom: 32px;
  }
`;

export const AccordionHead = styled.div`
  display: flex;
  align-items: ${(props) => props?.align || 'flex-start'};
  justify-content: ${(props) => props?.justify || 'flex-start'};
  margin: ${(props) => props?.margin || '0'};
  gap: 12px;
  position: relative;
  padding-bottom: unset;
  width: 100%;

  @media screen and (min-width: 768px) {
    background: #efe9fb;
    padding: 16px 20px;
    border-radius: ${(props) => props?.radius || '12px 12px 0 0'};
  }
`;

export const AccordionContent = styled.div`
  height: ${(props) => (props?.open ? 'unset' : '0')};
  opacity: ${(props) => (props?.open ? '1' : '0')};
  overflow: hidden;
  transition: all 0.25s ease-in;
`;

export const AccordionDropdown = styled.div`
  position: absolute;
  right: 0;
  transition: all 0.3s ease-in;
  transform: ${(props) => (props?.rotate ? 'rotate(180deg)' : 'rotate(0deg)')};

  @media screen and (min-width: 768px) {
    right: 20px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: ${(props) => props?.align || 'flex-start'};
  justify-content: ${(props) => props?.justify || 'space-between'};
  padding: 0 20px 16px 20px;
  text-align: ${(props) => props?.textAlign || ''};
`;

export const Text = styled.div`
  font-weight: ${(props) => props?.weight || '400'};
  font-size: ${(props) => props?.size || '0.875rem'};
  line-height: ${(props) => props?.lineHeight || '1.25rem'};
  color: ${(props) => props?.color || 'inherit'};
  margin: ${(props) => props?.margin || '0'};
  text-align: ${(props) => props?.align || ''};
  width: ${(props) => props?.width || 'initial'};
`;

export const Column = styled.div`
  display: flex;
  align-items: ${(props) => props?.align || 'flex-start'};
  justify-content: ${(props) => props?.justify || 'flex-start'};
  flex-direction: column;
  background: #f8f7fc;
  border-radius: ${(props) => props?.radius || '12px 12px 0 0'};
  padding: ${(props) => props?.padding || ' 16px 20px'};
`;

export const PerPerson = styled.div`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  display: inline-block;
  color: #5b5675;
  margin-left: 4px;
`;

export const Overview = styled.div`
  font-weight: ${(props) => props?.weight || '400'};
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${(props) => props?.color || '#5B5675'};
  padding: 4px 0 0 30px;
`;

export const InlineText = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #5b5675;
  display: inline;
`;

export const ButtonContainer = styled.div`
  width: inherit;
  padding-bottom: 24px;
`;

export const TnC = styled.div`
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  margin-top: 16px;
  margin-right: 10px;
`;

export const SkeletonContainer = styled.div`
  padding-bottom: 16px;
`;

export const DisclaimerCardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #e2f5ff;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 20px;
`;

export const DisclaimerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #5b5675;
`;

export const DisclaimerKnowMore = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  line-height: inherit;
  display: inline;
  color: #054599;
  text-decoration: underline;
  cursor: pointer;
`;

export const DisclaimerLine = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const DisclaimerIcon = styled.div`
  flex: 0 0 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
  @media screen and (max-width: 768px) {
    margin-top: 2px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
